import { useEffect, useRef, useState } from "react";
import { UserIcon } from 'assets/icons'

interface Option {
  id: string;
  name: string;
  image?: string | null;
}

interface ImageSelectProps {
  label: string;
  options: Option[];
  value?: string;
  onChange: (selected: Option) => void;
}

const ImageSelect: React.FC<ImageSelectProps> = ({ label, options, value, onChange }) => {
  const [selected, setSelected] = useState<Option | null>(null);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    const selectedOption = options.find(option => String(option.id) === value) || null;
    setSelected(selectedOption);
  }, [value, options]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (option: Option) => {
    setSelected(option);
    onChange(option);
    setOpen(false);
  };

  return (
    <div id="image-select-container">
      <label className="image-select-label">{label}</label>
      <div className="image-select" onClick={() => setOpen(!open)} ref={dropdownRef}>
        <div className="selected">
          {selected ? (
            <>
              {selected.image ? (
                <img src={selected.image} alt={selected.name} className="selected-img" />
              ) : (
                <img src={UserIcon} alt={selected.name} className="selected-img img-invert" />
              )}
              <span>{selected.name}</span>
            </>
          ) : (
            <span>Seleccione</span>
          )}
          <svg className="dropdown-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <path d="M7 10l5 5 5-5z" />
          </svg>
        </div>
        {open && (
          <div className="options">
            {options.length === 0 ? (
              <div className="option">
                <span>Sin resultados</span>
              </div>
            ) : (
              options.map(option => (
                <div key={option.id} className="option" onClick={() => handleSelect(option)}>
                  {option.image ? (
                    <img src={option.image} alt={option.name} className="option-img" />
                  ) : (
                    <img src={UserIcon} alt={option.name} className="option-img img-invert" />
                  )}
                  <span>{option.name}</span>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageSelect;